<template>
  <div>
    <div v-if="justView || addQuestionTemplate === 'default'" class="row">
      <div
        class="col-xl-8 mt-auto mb-auto text"
        :style="{
          color: textColor || '#000000',
        }"
      >
        <span :class="`${this.$route.fullPath.includes('treatments') ? 'text-addquestion' : ''}`"> {{ questionText }} </span>
      </div>
      <div
        v-if="justView"
        class="col-xl-4 text-center"
        style="display: flex; justify-content: center;"
      >
        <div v-if="selected === 1">
          <label class="icon" style="cursor: auto;">
            <i class="fas fa-frown icon-view"></i>
            <i class="fas fa-smile icon-view" style="color: green;"></i>
          </label>
        </div>
        <div v-else-if="selected === 0">
          <label class="icon" style="cursor: auto;">
            <i class="fas fa-frown icon-view" style="color: red;"></i>
            <i class="fas fa-smile icon-view"></i>
          </label>
        </div>
        <div v-else>
          <label class="icon" style="cursor: auto;">
            <i class="fas fa-frown icon-view"></i>
            <i class="fas fa-smile icon-view"></i>
          </label>
        </div>

        <applicable
          v-if="reviewAnswer === -1"
          :itemId="index"
          :justView="justView"
        />
      </div>
      <div v-else class="col-xl-4 text-center applicabled">
        <label class="icon">
          <input
            type="radio"
            :name="`emotion-${index}`"
            value="0"
            :checked="selected === 0"
            v-model="review"
            @click="handleClick($event.target.value)" />
           <i class="fas fa-frown icon-view frown"></i>
        </label>

        <label class="icon">
          <input
            type="radio"
            :name="`emotion-${index}`"
            value="1"
            :checked="selected === 1"
            v-model="review"
            @click="handleClick($event.target.value)"
          />
           <i class="fas fa-smile icon-view smile"></i>
        </label>

        <applicable
          v-if="applicableEnabled"
          :itemId="index"
          v-model="applicabled"
          @click.native="selectedButton = !selectedButton"
          :selectedButton="selectedButton"
          :lang="lang"
        />
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div
          class="col-xl-12 mt-auto mb-auto text align-center"
          :style="{
            color: textColor || '#000000',
          }"
        >
          {{ questionText }}
        </div>

        <div class="col-xl-12 text-center applicabled align-center">
          <label class="icon-big">
            <input
              type="radio"
              :name="`emotion-${index}`"
              value="0"
              :checked="selected === 0"
              v-model="review"
              @click="handleClick($event.target.value)" />
            <font-awesome-icon :icon="['fas', 'frown']" class="frown"
          /></label>

          <label class="icon-big">
            <input
              type="radio"
              :name="`emotion-${index}`"
              value="1"
              :checked="selected === 1"
              v-model="review"
              @click="handleClick($event.target.value)"
            />
            <font-awesome-icon :icon="['fas', 'smile']" class="smile" />
          </label>

          <applicable
            v-if="applicableEnabled"
            :itemId="index"
            v-model="applicabled"
            @click.native="selectedButton = !selectedButton"
            :selectedButton="selectedButton"
            :lang="lang"
          />
        </div>
      </div>
    </div>

    <comment-area
      :clickButton="expandComment"
      :template="addQuestionTemplate"
      v-if="commentEnabled && !justView"
      v-model="comment"
    />

    <p
      v-if="hasComment && justView"
      class="comment-area"
      :style="{
        color: textColor || '#000000',
      }"
    >
      Comentário: {{ hasComment }}
    </p>

    <hr />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import commentArea from '../comment-area';
import applicable from '../applicable';

export default {
  components: {
    commentArea,
    applicable,
  },

  props: {
    textColor: { type: String, required: false },
    questionText: { type: String, required: true },
    index: { type: Number, required: true },
    justView: { type: Boolean, default: false },
    itemId: { type: String, required: true },
    selected: { type: Number },
    myItems: { type: Number, required: false },
    commentEnabled: { type: Boolean, default: false },
    applicableEnabled: { type: Boolean, default: false },
    hasComment: { type: String, default: null },
    reviewAnswer: { type: Number, required: true },
    addQuestionTemplate: { type: String, required: true, default: 'default' },
    idQuestion: { type: String, required: true },
    lang: { type: String, default: 'br' }
  },
  data: () => ({
    position: null,
    review: null,
    comment: null,
    applicabled: null,
    selectedButton: false,
    expandComment: false,
  }),
  watch: {
    comment: function watchComment() {
      this.update();
    },
    applicabled: function watchApplicated(value) {
      this.$emit('input', {
        review: value,
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
    selectedButton: function watchSelectedButton(value) {
      if (value) {
        this.selectedButton = true;
        this.review = null;

        this.$emit('input', {
          review: -1,
          comment: this.comment,
          position: this.itemId,
          _id: this.idQuestion,
        });
      }
    },
  },
  computed: {
    ...mapState('research', ['emotionReview']),
  },
  methods: {
    update() {
      this.$emit('input', {
        review: this.review,
        comment: this.comment,
        position: this.itemId,
        _id: this.idQuestion,
      });
    },
    handleClick(value) {
      if (this.review === value) {
        this.expandComment = false;
        this.review = null;
      } else {
        this.expandComment = true;
        this.review = value;
      }

      this.selectedButton = false;

      this.update();
    },
  },
  mounted() {
    this.position = this.$store.state.research.emotionControl;
    this.$store.state.research.emotionControl += 1;

    if (this.$route.name === 'Detalhes da tratativa') {
      document.querySelector('.applicabled').style.display = 'block';
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.align-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.applicabled {
  display: flex;
  justify-content: center;
}

@media only screen and (max-width: 1200px) {
  .text {
    text-align: center;
  }
}

.icon {
  padding: 10px 0 0 0;
  font-size: 25px;
  color: $gray;
  &:hover {
    cursor: pointer;
  }
}

.icon-big {
  padding: 10px 0 0 0;
  font-size: 40px;
  color: $gray;
  &:hover {
    cursor: pointer;
  }
}

.icon-view {
  font-size: 22px;
  margin-left: 20px;
  color: $gray;
}

.smile {
  margin-left: 15px;
  &:hover {
    color: #64b64d;
  }
}

.frown {
  &:hover {
    color: red;
  }
}

input[type='radio'] {
  display: none;
  &:checked {
    ~ .frown {
      color: red;
    }
    ~ .smile {
      color: #64b64d;
    }
  }
}

.col-metrics {
  display: flex;
  justify-content: flex-end;
}

.comment-area {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metrics/emotion/index.vue